<template>
  <div
    id="instruction-comment-item"
    class="instruction-comment-item py-1.5 px-3 rounded hover:bg-hover-state cursor-pointer"
    :class="[editOpened ? 'bg-hover-state' : 'bg-pure-white']"
  >
    <div v-if="!editOpened" class="comment-body flex flex-col gap-1">
      <div class="flex items-center justify-between gap-4 truncate">
        <div class="flex items-center gap-2 truncate">
          <div
            class="h-6 w-6 flex-shrink-0 flex items-center justify-center rounded-full bg-success-100"
          >
            <BlTextBody2
              :title="comment.user_name || 'Deleted user'"
              :text="(comment.user_name || 'Deleted user').at(0)"
              class="text-success-400"
            />
          </div>
          <BlTextSubtitle3
            v-if="!comment.user_name"
            title="Deleted user"
            text="Deleted user"
            class="italic"
          />
          <BlTextSubtitle3
            v-else
            :text="comment.user_name"
            class="text-slate-800 truncate"
          />
        </div>
        <div class="flex items-center gap-1">
          <BlTextBody2
            v-if="comment.is_edited"
            text="Edited"
            class="text-slate-600"
          />
          <BlTextBody2
            :text="displayDate(comment.updated_at, 'DD/MM/YY')"
            class="text-slate-600"
          />
          <BlTextBody2
            :text="displayDate(comment.updated_at, 'HH:mm')"
            class="text-slate-600"
          />
          <div v-if="comment.user_id === currentUser.id" class="comment-action">
            <div class="flex items-center gap-1">
              <div
                class="h-5.5 w-5.5 flex items-center justify-center rounded hover:bg-slate-500 cursor-pointer"
                @click="deleteOpened = true"
                title="Remove comment"
              >
                <BlIcon icon="delete" color="slate-6" class="w-4 h-4" />
              </div>
              <div
                class="h-5.5 w-5.5 flex items-center justify-center rounded hover:bg-slate-500 cursor-pointer"
                @click="editOpened = true"
                title="Edit comment"
              >
                <BlIcon icon="edit" color="slate-6" class="w-4 h-4" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pl-8 flex">
        <div v-html="comment.body" class="text-slate-700 text-sm"></div>
      </div>
    </div>
    <div v-else class="w-full flex gap-2">
      <div
        class="h-6 w-6 flex-shrink-0 flex items-center justify-center rounded-full bg-success-100"
      >
        <BlTextBody2
          :title="comment.user_name || 'Deleted user'"
          :text="(comment.user_name || 'Deleted user').at(0)"
          class="text-success-400"
        />
      </div>
      <div v-if="editOpened" class="pb-px w-full relative">
        <div class="absolute top-2 right-2 flex items-center gap-2">
          <BlInputButton
            type="plain"
            dense
            label="Cancel"
            :loading="submitLoading"
            @clicked="editOpened = false"
          />
          <BlInputButton
            label="Save"
            dense
            :disabled="isDisabledSubmit"
            :loading="submitLoading"
            @clicked="onUpdate"
          />
        </div>
        <VueEditor
          :editor-toolbar="customToolbar"
          v-model="bodyInput"
          class="blum-editor"
          placeholder="Comment this instruction"
        />
      </div>
    </div>

    <BlBackdrop
      v-if="deleteOpened"
      title="Delete comment"
      description="You are about to delete the comment. Are you sure you want to proceed? This action is irreversible."
      label="Delete"
      type="error"
      :disabled="deleteLoading"
      @backdrop-close="deleteOpened = false"
      @backdrop-action="onRemove"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { VueEditor } from "vue2-editor";

import BlIcon from "../../../../BlIcon.vue";
import BlTextTitle4 from "../../../../BlTextTitle4.vue";
import BlTextSubtitle3 from "../../../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../../../BlTextBody2.vue";
import BlInputButton from "../../../../BlInputButton.vue";
import BlBackdrop from "../../../../BlBackdrop.vue";

export default {
  name: "InstructionCommentItem",
  components: {
    VueEditor,
    BlIcon,
    BlTextTitle4,
    BlTextSubtitle3,
    BlTextBody2,
    BlInputButton,
    BlBackdrop
  },
  props: {
    comment: { type: Object, required: true }
    // @toggle-edit-state
  },
  data() {
    return {
      submitLoading: false,
      editOpened: false,
      bodyInput: "",
      customToolbar: [["bold", "italic", "underline", "link"]],
      deleteOpened: false,
      deleteLoading: false
    };
  },
  computed: {
    ...mapGetters(["currentUser", "prospectStage"]),
    isDisabledSubmit() {
      if (!this.bodyInput) return true;
      return false;
    }
  },
  watch: {
    editOpened(val) {
      this.$emit("toggle-edit-state", val);
      if (val) {
        this.bodyInput = this.comment.body;
      }
    }
  },
  methods: {
    ...mapActions(["updateInstructionComment", "deleteInstructionComment"]),
    displayDate(date, format) {
      if (!date) return "-";
      return moment(date).format(format);
    },
    onUpdate() {
      const data = {
        prospect_stage_id: this.prospectStage.id,
        id: this.comment.id,
        comment: { body: this.bodyInput }
      };
      this.submitLoading = true;
      this.updateInstructionComment(data).then(({ success }) => {
        this.submitLoading = false;
        if (!success) return;
        this.editOpened = false;
      });
    },
    onRemove() {
      const data = {
        prospect_stage_id: this.prospectStage.id,
        id: this.comment.id
      };
      this.deleteLoading = true;
      this.deleteInstructionComment(data).then(({ success }) => {
        this.deleteLoading = false;
        if (!success) return;
        this.deleteOpened = false;
      });
    }
  }
};
</script>

<style lang="scss">
.instruction-comment-item {
  .comment-body {
    .comment-action {
      display: none;
    }
  }
  .comment-body:hover {
    .comment-action {
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/salesPipeline/modal/prospectPanel/instructionComment/Item.vue